import { RepositoryFactory } from "../../api/RepositoryFactory";
import i18n from "@/plugins/i18n";

const TagRepository = RepositoryFactory.get("tag");

export const tag = {
  namespaced: true,
  state: {
    tags: [],
    gotthard: [],
    status: {
      loading: false
    }
  },

  actions: {
    async getTags({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await TagRepository.get(user)
        .then(tags => {
          commit("GET_TAGS", tags.data);
          commit("LOADING", false);
        })
        .catch(res => {
          if (res.response !== undefined && res.response.status === 401) {
            dispatch(
              "users/login",
              {
                email: rootState.users.credentials.email,
                password: rootState.users.credentials.password
              },

              { root: true }
            );
          }

          dispatch("alert/error", i18n.t("common.error"), { root: true });
          commit("LOADING", false);
        });

      commit("LOADING", false);
    },

    async getGotthardp({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await TagRepository.getGotthardp(user)
        .then(tags => {
          commit("GET_GOTTHARD", tags.data);
          commit("LOADING", false);
        })
        .catch(res => {
          if (res.response !== undefined && res.response.status === 401) {
            dispatch(
              "users/login",
              {
                email: rootState.users.credentials.email,
                password: rootState.users.credentials.password
              },

              { root: true }
            );
          }

          dispatch("alert/error", i18n.t("common.error"), { root: true });
          commit("LOADING", false);
        });

      commit("LOADING", false);
    },

    async updateTag({ dispatch, commit, rootState }, item) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await TagRepository.updateTag(user, item)
        .then(() => {
          dispatch("getTags")
          commit("LOADING", false);
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), { root: true });
          commit("LOADING", false);
        });

      commit("LOADING", false);
    },

    resetState({ commit }) {
      commit("RESET_STATE")
    }
  },

  mutations: {
    LOADING(state, status) {
      state.status.loading = status;
    },

    GET_TAGS(state, tags) {
      state.tags = tags;
    },

    GET_GOTTHARD(state, gws) {
      state.gotthard = gws;
    },

    // eslint-disable-next-line
    RESET_STATE(state) {
      state = {
        epiroc: [],
        status: {
          loading: false
        }
      };
    }
  }
};
